// TypeScript Interfaces für Halter basierend auf HalterGKSClient Schema aus API-Dokumentation

// Halter Interface basierend auf HalterGKSClient Schema aus API-Dokumentation
export interface Halter {
  id?: number;
  personTyp: string;
  vorname?: string;
  nachname?: string;
  firma?: string;
  geburtsdatum?: string;
  geburtsort?: string;
  geschlecht?: string;
  strasse?: string;
  hausnummer?: string;
  adresszusatz?: string;
  plz?: string;
  ort?: string;
  land?: string;
  telefon?: string;
  email?: string;
  iban?: string;
  erstelltAm?: string;
}

// Enum für PersonTyp
export enum PersonTyp {
  NATUERLICHE_PERSON = 'NATUERLICH',
  JURISTISCHE_PERSON = 'JURISTISCH'
}

// Enum für Geschlecht
export enum Geschlecht {
  MAENNLICH = 'MAENNLICH',
  WEIBLICH = 'WEIBLICH',
  DIVERS = 'DIVERS'
}

// Helper-Funktion für benutzerfreundliche Anzeige von Geschlecht
export const getGeschlechtLabel = (geschlecht?: string): string => {
  if (!geschlecht) return 'Nicht angegeben';
  
  const labels: Record<string, string> = {
    'MAENNLICH': 'Männlich',
    'WEIBLICH': 'Weiblich',
    'DIVERS': 'Divers'
  };
  
  return labels[geschlecht] || geschlecht;
};

// Interface für Halter Update Requests
export interface HalterUpdateRequest extends Omit<Halter, 'id' | 'erstelltAm'> {}

// Interface für Halter Create Requests
export interface HalterCreateRequest extends Omit<Halter, 'id' | 'erstelltAm'> {}

// Interface für Halter Create Data (ohne ID)
export interface HalterCreateData extends Omit<Halter, 'id' | 'erstelltAm'> {}

// Interface für paginierte Halter-Listen
export interface HalterPage {
  content: Halter[];
  totalPages: number;
  totalElements: number;
  number: number;
  size: number;
}
